module.exports = __webpack_public_path__ + "fonts/EuclidEnercity-BoldItalic-WebS.8aff64ea.ttf";